var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',_vm._b({},'th',_vm.attributes,false),[(_vm.isText)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._l((_vm.mappedComponents),function(item,index){return _c(item.component,{key:`${item.type}-${index}`,tag:"component",attrs:{"contents":item.contents}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }